import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c5314e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "records-group" }
const _hoisted_2 = { class: "group-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'notifications-container',
  props: {
  /**
   * Text to display in the header of the container
   * @type {String}
   * @required
   */
  title: {
    type: String,
    required: true,
  },
},
  emits: [
  /** Triggers when the user clicks the clear icon */
  "clearAllClicked",
],
  setup(__props, { emit }) {





const onClearClicked = () => emit("clearAllClicked");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(__props.title), 1),
      _hoisted_3,
      _createElementVNode("i", {
        class: "fa-regular fa-circle-xmark",
        onClick: onClearClicked
      })
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})